import React, { useEffect, useReducer, useState, useContext } from 'react'
import CustomAddPage from '../../components/CustomComponents/CustomAddPage'
import { UserContext } from '../../context api/UserContext'
import { usePermissions } from '../../hooks/Authentication/usePermissions'

export default function AddPermission({ permission }) {
  const [modules, setModules] = useState({
    EMPLOYEE: {
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
      UPLOAD: false,
      FLAG: false,
    },
    LEAD: {
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
      UPLOAD: false,
      FLAG: false,
    },
    SALES: {
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
      UPLOAD: false,
      FLAG: false,
    },
    PRODUCT: {
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
      UPLOAD: false,
      FLAG: false,
    },
    LEARNING: {
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
      UPLOAD: false,
      FLAG: false,
    },
    AUDIT: {
      CREATE: true,
      READ: false,
      UPDATE: false,
      DELETE: false,
      UPLOAD: false,
      FLAG: false,
    },
  })

  const [tempModule, setTempModule] = useState({})
  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0)
  const [fetched, setFetched] = useState(false)
  function handleClickNew() {
    forceUpdate()
  }

  const [form, setForm] = useState({
    name: '',
    permissionCode: '',
    active: true,
  })
  const { addPermissions, loading, updatePermissions, getModules, moduleName, actionName, mappedModules } = usePermissions()

  const handleSubmit = () => {
    if (permission) {
      updatePermissions({ ...form, module: Object.keys(tempModule), subPermission: Object.values(tempModule), permissionId: permission._id })
    } else {
      addPermissions({ ...form, module: Object.keys(tempModule), subPermission: Object.values(tempModule) })
    }
  }
  const inputFields = [
    { label: 'Permission Code', value: form.permissionCode, name: 'permissionCode' },
    { label: 'Name', value: form.name, name: 'name' },
    { label: 'Status', value: form.active, type: 'ACTIVE' },
  ]
  useEffect(()=>{
    // if(!fetched){
      if(!mappedModules)
       getModules();
      // setFetched(true);
  // }
}, [mappedModules])

  useEffect(()=>{
      console.log({mappedModules})
  }, [fetched])
  useEffect(()=>{
    console.log("moduleName", moduleName, "actionName", actionName, "mappedModules", mappedModules)

  }, [moduleName, actionName, mappedModules])

  useEffect(() => {
    if (permission) {
      console.log(permission, 'sparsh')
      let crudOperation = permission.allowed
      let crud = {}
      crudOperation.forEach((element) => {
        crud[element.module] = element.subPermission
      })
      console.log(crud)
      setTempModule(crud)
      setForm({ ...permission })
    }
  }, [permission])

  return (
    <CustomAddPage
      heading="Permission"
      redirect="PERMISSIONS"
      currentData={permission}
      loading={loading}
      state={form}
      setState={setForm}
      handleClick={handleSubmit}
      inputFields={inputFields}
      modules={modules}
      setModules={setModules}
      tempModule={tempModule}
      moduleName = {moduleName}
      actionName = {actionName}
      mappedModules={mappedModules && mappedModules}
      setTempModule={(obj) => {
        setTempModule(obj)
        handleClickNew()
      }}
    />
  )
}
